/**
 * Menu script
 */
class Bookero_Menu {
    constructor() {
        this.initState();
        this.initEvents();
    }

    initState() {
        this.win = $(window);
        this.menuWrapper = $('.page-header');
        this.menuIcon = this.menuWrapper.find('.menu-toggle');
        this.menuBlock = this.menuWrapper.find('.menu');
        this.menuItem = this.menuBlock.find('.menu-item a');
    }

    initEvents() {
        $(window).on('scroll', () => {
            let positionY = this.win.scrollTop();

            if (positionY > 80 && !this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.addClass('is-fixed');
                return;
            }

            if (positionY <= 80 && this.menuWrapper.hasClass('is-fixed')) {
                this.menuWrapper.removeClass('is-fixed');
            }
        });

        if (this.menuIcon.length) {
            this.menuIcon.on('click', e => {
                e.preventDefault();
                let menuIconValue = this.menuIcon.attr('aria-expanded');
                this.menuBlock.toggleClass('is-active');
                this.menuIcon.toggleClass('is-active');
                this.menuIcon.attr('aria-expanded', 'true');
                
                $(document.body).toggleClass('no-scroll');

                if ( menuIconValue === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }

                setTimeout(() => {
                    this.menuBlock.toggleClass('is-showing');
                }, 150);
            });

            this.menuItem.on('click', () => {
                let menuIconValue = this.menuIcon.attr('aria-expanded');
                this.menuBlock.removeClass('is-showing');
                this.menuIcon.removeClass('is-active');
                this.menuIcon.attr('aria-expanded', 'false');
                
                $(document.body).removeClass('no-scroll');

                if ( menuIconValue === 'true') {
                    this.menuIcon.attr('aria-expanded', 'false');
                }

                setTimeout(() => {
                    this.menuBlock.removeClass('is-active');
                }, 150);
            });
        }
    }
}
